import React from "react";
import { getStyleObject } from "../_global";

export class EmojiDisplay extends React.Component {
    constructor(props) {
        super(props);

        this.select = this.select.bind(this);
    }

    select() {
        // select on click
        if(this.props.active == 0) {
            // if not selected
            this.props.select(this.props.zIndex - 1);
        }
        else {
            // if selected, select the next one down
            this.props.select(-1);
        }
    }


    render() {
        
        // style
        var style = getStyleObject({
            xOffset: this.props.info.xOffset,
            yOffset: this.props.info.yOffset,
            scale: this.props.info.scale,
            rotation: this.props.info.rotation,
            hFlip: this.props.info.hFlip,
            vflip: this.props.info.vFlip,
            hidden: this.props.info.hidden
        }, this.props.zIndex);
        
        // active
        var classes = "emoji-display ";

        if(this.props.active) {
            classes += "selected ";
        }
        

        return (
            <div className={classes} style={{"zIndex": this.props.zIndex}}>
                <img 
                    src={"./img/" + this.props.info.collection + "/" + this.props.section + "/" + this.props.icon + ".png"} 
                    alt={this.props.icon}
                    onClick={this.select} 
                    style={style} 
                    id={"layer-" + this.props.zIndex}
                    draggable="false"
                />
            </div>
        );
    }
}
